import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocaleProvider } from './i18n/LocaleProvider';
import JobsList from './pages/JobsList';
import JobDetail from './pages/JobDetail';
import NotFound from './pages/NotFound';

function App() {
  return (
    <LocaleProvider>
      <Router>
        <Routes>
          <Route path="/" element={<JobsList />} />
          <Route path="/:slug" element={<JobDetail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </LocaleProvider>
  );
}

export default App;
